import React from 'react';
import { Box, Typography } from '@mui/material';
import { DetailsRow } from '../../../components/DetailsRow';
import PartyDisplay from '../../../components/PartyDisplay';
import { StateCell, Status } from '../../../components/StateCell';
import { fmt } from '../../../utils/common';
import { Direction } from './Direction';
import { Row } from './types';

interface TransferDetailsProps {
  row?: Row;
}
export const TransferDetails: React.FC<TransferDetailsProps> = ({ row }) => {
  if (!row) {
    return null;
  }
  const details = [
    {
      label: 'state',
      value: <StateCell state={row.state as Status} reason={row.reason} />,
    },
    {
      label: 'sender',
      value: (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Direction sender={row.payload.sender} receiver={row.payload.receiver} />
          <PartyDisplay party={row.payload.sender} />
        </Box>
      ),
    },
    {
      label: 'receiver',
      value: row.payload.receiver,
    },
    {
      label: 'Instrument',
      value: row.payload.instrumentIdentifier.id,
    },
    {
      label: 'amount',
      value: fmt(row.payload.amount, 2),
    },
    {
      label: 'registrar',
      value: row.payload.registrar,
    },
    {
      label: 'operator',
      value: row.payload.operator,
    },
    {
      label: 'provider',
      value: row.payload.provider,
    },
    {
      label: 'reference',
      value: row.payload.reference,
    },
  ];
  if (row.payload.executeBefore) {
    details.splice(1, 0, {
      label: 'execute before (local time)',
      value: `${new Date(row.payload.executeBefore).toLocaleString()}`,
    });
  }

  if (row.reason) {
    details.splice(1, 0, {
      label: 'reason',
      value: row.reason,
    });
  }
  return (
    <Box
      sx={{
        flex: 1,
        flexDirection: 'column',
        overflowY: 'auto',
        flexGrow: 1,
        display: 'flex',
        overflow: 'hidden',
        pt: 1,
      }}
    >
      <Typography variant="body2" fontWeight="bold">
        Details
      </Typography>
      {details.map((detail) => (
        <DetailsRow key={detail.label} value={detail.value} label={detail.label} />
      ))}
    </Box>
  );
};
